// utils
import { axiosInstance as axios } from '../../utils/axios';

// ----------------------------------------------------------------------

export function getActivity(businessId) {
  return async () => {
    try {
      const response = await axios.get('/activity', { headers: { 'X-Business': businessId } });
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, data: error };
    }
  };
}
